import React, { useState } from 'react';
import slika1 from '../assets/slika1.jpeg';
import slika2 from '../assets/slika2.jpeg';
import slika3 from '../assets/slika3.jpeg';
import slika4 from '../assets/slika4.jpg';
import slika5 from '../assets/slika5.jpg';
import slika6 from '../assets/slika6.jpg';
import slika7 from '../assets/slika7.jpeg';
import slika8 from '../assets/slika8.jpeg';

// Primer podataka o stanovima
const stanoviData = [
  {
    id: 1,
    title: 'Novi Sad, Bulevar Evrope 20',
    location: 'Novi Sad, Bulevar Evrope 20',
    price: 270,
    area: 23,
    rooms: 0.5,
    type: 'Garsonjera',
    date: '19/08/24',
    images: [slika1, slika2, slika3],
    sifra: 'A50-1478',
    kupatila: 1,
    parking: true,
    namena: 'Iznajmljivanje',
    garaza: 'Nema',
    spratovi: 1,
    namestenost: 'Namešten',
    drzava: 'Srbija',     // Dodajemo državu
    grad: 'Novi Sad',     // Dodajemo grad
    transakcija: 'Izdavanje', // Tip transakcije
  },
  {
    id: 2,
    title: 'Novi Sad, Novo Naselje 30',
    location: 'Novi Sad, Novo Naselje 30',
    price: 450,
    area: 40,
    rooms: 1.5,
    type: 'Stan',
    date: '19/08/24',
    images: [slika5, slika6, slika4],
    sifra: 'A50-1480',
    kupatila: 1,
    parking: true,
    namena: 'Prodaja',
    garaza: 'Da',
    spratovi: 2,
    namestenost: 'Polunamešten',
    drzava: 'Srbija',
    grad: 'Novi Sad',
    transakcija: 'Prodaja',
  },
  {
    id: 3,
    title: 'Beograd, Zemun 15',
    location: 'Beograd, Zemun 15',
    price: 680,
    area: 60,
    rooms: 2,
    type: 'Stan',
    date: '19/08/24',
    images: [slika7, slika8, slika3],
    sifra: 'A50-1490',
    kupatila: 2,
    parking: true,
    namena: 'Iznajmljivanje',
    garaza: 'Nema',
    spratovi: 1,
    namestenost: 'Prazan',
    drzava: 'Srbija',
    grad: 'Beograd',
    transakcija: 'Izdavanje',
  },
  {
    id: 4,
    title: 'Novi Sad, Liman 2',
    location: 'Novi Sad, Liman 2',
    price: 320,
    area: 30,
    rooms: 1,
    type: 'Garsonjera',
    date: '19/08/24',
    images: [slika2, slika5, slika4],
    sifra: 'A50-1500',
    kupatila: 1,
    parking: false,
    namena: 'Iznajmljivanje',
    garaza: 'Nema',
    spratovi: 5,
    namestenost: 'Polunamešten',
    drzava: 'Srbija',
    grad: 'Novi Sad',
    transakcija: 'Izdavanje',
  },
  {
    id: 5,
    title: 'Novi Sad, Grbavica 45',
    location: 'Novi Sad, Grbavica 45',
    price: 590,
    area: 45,
    rooms: 1.5,
    type: 'Stan',
    date: '19/08/24',
    images: [slika3, slika8, slika1],
    sifra: 'A50-1505',
    kupatila: 1,
    parking: true,
    namena: 'Prodaja',
    garaza: 'Da',
    spratovi: 2,
    namestenost: 'Namešten',
    drzava: 'Srbija',
    grad: 'Novi Sad',
    transakcija: 'Prodaja',
  },
  {
    id: 6,
    title: 'Niš, Centar 8',
    location: 'Niš, Centar 8',
    price: 420,
    area: 40,
    rooms: 1,
    type: 'Stan',
    date: '19/08/24',
    images: [slika6, slika4, slika5],
    sifra: 'A50-1600',
    kupatila: 1,
    parking: false,
    namena: 'Iznajmljivanje',
    garaza: 'Nema',
    spratovi: 3,
    namestenost: 'Polunamešten',
    drzava: 'Srbija',
    grad: 'Niš',
    transakcija: 'Izdavanje',
  },
  {
    id: 7,
    title: 'Kragujevac, Stanovi 3',
    location: 'Kragujevac, Stanovi 3',
    price: 750,
    area: 75,
    rooms: 3,
    type: 'Stan',
    date: '19/08/24',
    images: [slika8, slika7, slika6],
    sifra: 'A50-1650',
    kupatila: 2,
    parking: true,
    namena: 'Prodaja',
    garaza: 'Da',
    spratovi: 2,
    namestenost: 'Namešten',
    drzava: 'Srbija',
    grad: 'Kragujevac',
    transakcija: 'Prodaja',
  },  {id: 8,
  title: 'Novi Sad, Bulevar Evrope 20',
  location: 'Novi Sad, Bulevar Evrope 20',
  price: 270,
  area: 23,
  rooms: 0.5,
  type: 'Garsonjera',
  date: '19/08/24',
  images: [slika1, slika2, slika3],
  sifra: 'A50-1478',
  kupatila: 1,
  parking: true,
  namena: 'Iznajmljivanje',
  garaza: 'Nema',
  spratovi: 1,
  namestenost: 'Namešten',
  drzava: 'Srbija',     // Dodajemo državu
  grad: 'Novi Sad',     // Dodajemo grad
  transakcija: 'Izdavanje', // Tip transakcije
},
{
  id: 9,
  title: 'Novi Sad, Novo Naselje 30',
  location: 'Novi Sad, Novo Naselje 30',
  price: 450,
  area: 40,
  rooms: 1.5,
  type: 'Stan',
  date: '19/08/24',
  images: [slika5, slika6, slika4],
  sifra: 'A50-1480',
  kupatila: 1,
  parking: true,
  namena: 'Prodaja',
  garaza: 'Da',
  spratovi: 2,
  namestenost: 'Polunamešten',
  drzava: 'Srbija',
  grad: 'Novi Sad',
  transakcija: 'Prodaja',
},
{
  id: 10,
  title: 'Beograd, Zemun 15',
  location: 'Beograd, Zemun 15',
  price: 680,
  area: 60,
  rooms: 2,
  type: 'Stan',
  date: '19/08/24',
  images: [slika7, slika8, slika3],
  sifra: 'A50-1490',
  kupatila: 2,
  parking: true,
  namena: 'Iznajmljivanje',
  garaza: 'Nema',
  spratovi: 1,
  namestenost: 'Prazan',
  drzava: 'Srbija',
  grad: 'Beograd',
  transakcija: 'Izdavanje',
},
{
  id: 11,
  title: 'Novi Sad, Liman 2',
  location: 'Novi Sad, Liman 2',
  price: 320,
  area: 30,
  rooms: 1,
  type: 'Garsonjera',
  date: '19/08/24',
  images: [slika2, slika5, slika4],
  sifra: 'A50-1500',
  kupatila: 1,
  parking: false,
  namena: 'Iznajmljivanje',
  garaza: 'Nema',
  spratovi: 5,
  namestenost: 'Polunamešten',
  drzava: 'Srbija',
  grad: 'Novi Sad',
  transakcija: 'Izdavanje',
},
{
  id: 12,
  title: 'Novi Sad, Grbavica 45',
  location: 'Novi Sad, Grbavica 45',
  price: 590,
  area: 45,
  rooms: 1.5,
  type: 'Stan',
  date: '19/08/24',
  images: [slika3, slika8, slika1],
  sifra: 'A50-1505',
  kupatila: 1,
  parking: true,
  namena: 'Prodaja',
  garaza: 'Da',
  spratovi: 2,
  namestenost: 'Namešten',
  drzava: 'Srbija',
  grad: 'Novi Sad',
  transakcija: 'Prodaja',
}, {
  id: 13,
  title: 'Novi Sad, Bulevar Evrope 20',
  location: 'Novi Sad, Bulevar Evrope 20',
  price: 120000,
  area: 50,
  rooms: 2,
  type: 'Stan',
  date: '19/08/24',
  sifra: 'A50-1234',
  kupatila: 1,
  garaza: 'Da',
  spratovi: 1,
  namena: 'Prodaja',
  namestenost: 'Polunamešten',
  parking: 'Da',
  images: [slika1, slika2, slika3],
},
{
  id: 14,
  title: 'Novi Sad, Novo Naselje 30',
  location: 'Novi Sad, Novo Naselje 30',
  price: 150000,
  area: 60,
  rooms: 3,
  type: 'Stan',
  date: '19/08/24',
  sifra: 'A50-5678',
  kupatila: 2,
  garaza: 'Ne',
  spratovi: 2,
  namena: 'Prodaja',
  namestenost: 'Prazan',
  parking: 'Ne',
  images: [slika5, slika6, slika4],
},
{
  id: 15,
  title: 'Beograd, Zemun 5',
  location: 'Beograd, Zemun 5',
  price: 220000,
  area: 85,
  rooms: 4,
  type: 'Kuća',
  date: '19/08/24',
  sifra: 'A50-6543',
  kupatila: 2,
  garaza: 'Da',
  spratovi: 2,
  namena: 'Prodaja',
  namestenost: 'Prazan',
  parking: 'Ne',
  images: [slika3, slika6, slika7],
},
{
  id: 16,
  title: 'Novi Sad, Novo Naselje 40',
  location: 'Novi Sad, Novo Naselje 40',
  price: 140000,
  area: 55,
  rooms: 2.5,
  type: 'Stan',
  date: '19/08/24',
  sifra: 'A50-7890',
  kupatila: 1,
  garaza: 'Da',
  spratovi: 1,
  namena: 'Prodaja',
  namestenost: 'Namešten',
  parking: 'Da',
  images: [slika7, slika8, slika2],
},
{
  id: 17,
  title: 'Beograd, Zemun 5',
  location: 'Beograd, Zemun 5',
  price: 220000,
  area: 85,
  rooms: 4,
  type: 'Kuća',
  date: '19/08/24',
  sifra: 'A50-6543',
  kupatila: 2,
  garaza: 'Da',
  spratovi: 2,
  namena: 'Prodaja',
  namestenost: 'Prazan',
  parking: 'Ne',
  images: [slika3, slika6, slika7],
},
{
  id: 18,
  title: 'Niš, Centar 10',
  location: 'Niš, Centar 10',
  price: 180000,
  area: 70,
  rooms: 3,
  type: 'Stan',
  date: '19/08/24',
  sifra: 'A50-2345',
  kupatila: 1,
  garaza: 'Ne',
  spratovi: 1,
  namena: 'Prodaja',
  namestenost: 'Polunamešten',
  parking: 'Da',
  images: [slika5, slika2, slika4],
},
{
  id: 19,
  title: 'Novi Sad, Bulevar Evrope 20',
  location: 'Novi Sad, Bulevar Evrope 20',
  price: 120000,
  area: 50,
  rooms: 2,
  type: 'Stan',
  date: '19/08/24',
  sifra: 'A50-1234',
  kupatila: 1,
  garaza: 'Da',
  spratovi: 1,
  namena: 'Prodaja',
  namestenost: 'Polunamešten',
  parking: 'Da',
  images: [slika1, slika2, slika3],
},{
  id: 20,
  title: 'Beograd, Zemun 5',
  location: 'Beograd, Zemun 5',
  price: 220000,
  area: 85,
  rooms: 4,
  type: 'Kuća',
  date: '19/08/24',
  sifra: 'A50-6543',
  kupatila: 2,
  garaza: 'Da',
  spratovi: 2,
  namena: 'Prodaja',
  namestenost: 'Prazan',
  parking: 'Ne',
  images: [slika3, slika6, slika7],
},
{
  id: 21,
  title: 'Niš, Centar 10',
  location: 'Niš, Centar 10',
  price: 180000,
  area: 70,
  rooms: 3,
  type: 'Stan',
  date: '19/08/24',
  sifra: 'A50-2345',
  kupatila: 1,
  garaza: 'Ne',
  spratovi: 1,
  namena: 'Prodaja',
  namestenost: 'Polunamešten',
  parking: 'Da',
  images: [slika5, slika2, slika4],
},
{
  id: 22,
  title: 'Novi Sad, Bulevar Evrope 20',
  location: 'Novi Sad, Bulevar Evrope 20',
  price: 120000,
  area: 50,
  rooms: 2,
  type: 'Stan',
  date: '19/08/24',
  sifra: 'A50-1234',
  kupatila: 1,
  garaza: 'Da',
  spratovi: 1,
  namena: 'Prodaja',
  namestenost: 'Polunamešten',
  parking: 'Da',
  images: [slika1, slika2, slika3],
},{
  id: 23,
  title: 'Beograd, Zemun 5',
  location: 'Beograd, Zemun 5',
  price: 220000,
  area: 85,
  rooms: 4,
  type: 'Kuća',
  date: '19/08/24',
  sifra: 'A50-6543',
  kupatila: 2,
  garaza: 'Da',
  spratovi: 2,
  namena: 'Prodaja',
  namestenost: 'Prazan',
  parking: 'Ne',
  images: [slika3, slika6, slika7],
},
{
  id: 24,
  title: 'Niš, Centar 10',
  location: 'Niš, Centar 10',
  price: 180000,
  area: 70,
  rooms: 3,
  type: 'Stan',
  date: '19/08/24',
  sifra: 'A50-2345',
  kupatila: 1,
  garaza: 'Ne',
  spratovi: 1,
  namena: 'Prodaja',
  namestenost: 'Polunamešten',
  parking: 'Da',
  images: [slika5, slika2, slika4],
},
];

const MenuHome = ({ onSearch }) => {
  const [section1, setSection1] = useState({ current: 'Prodaja', options: ['Prodaja', 'Izdavanje'] });
  const [section2, setSection2] = useState({ current: 'Srbija', options: ['Hrvatska', 'Crna Gora'] });
  const [section3, setSection3] = useState({ current: 'Novi Sad', options: ['Beograd', 'Subotica'] });
  const [section4, setSection4] = useState({ current: 'Stan', options: ['Kuća', 'Stan', 'Poslovni prostor'] });

  const [isSection1Open, setIsSection1Open] = useState(false);
  const [isSection2Open, setIsSection2Open] = useState(false);
  const [isSection3Open, setIsSection3Open] = useState(false);
  const [isSection4Open, setIsSection4Open] = useState(false);

  const toggleSection1 = () => {
    setIsSection1Open(!isSection1Open);
    setIsSection2Open(false);
    setIsSection3Open(false);
    setIsSection4Open(false);
  };

  const toggleSection2 = () => {
    setIsSection2Open(!isSection2Open);
    setIsSection1Open(false);
    setIsSection3Open(false);
    setIsSection4Open(false);
  };

  const toggleSection3 = () => {
    setIsSection3Open(!isSection3Open);
    setIsSection1Open(false);
    setIsSection2Open(false);
    setIsSection4Open(false);
  };

  const toggleSection4 = () => {
    setIsSection4Open(!isSection4Open);
    setIsSection1Open(false);
    setIsSection2Open(false);
    setIsSection3Open(false);
  };

  const handleSelection = (section, setSection, selectedOption, setIsOpen) => {
    setSection((prevSection) => ({
      current: selectedOption,
      options: [...prevSection.options.filter(option => option !== selectedOption), prevSection.current],
    }));
    setIsOpen(false);
  };

  const handleSearch = () => {
    const filtered = stanoviData.filter(
      (stan) =>
        stan.transakcija === section1.current &&
        stan.drzava === section2.current &&
        stan.grad === section3.current &&
        stan.type === section4.current
    );
    onSearch(filtered);
  };

  return (
    <div className="relative bg-gray-800 text-white p-2 md:p-3 lg:p-4 rounded-lg shadow-lg flex flex-row space-x-2 md:space-x-4 justify-center w-full">
      <div className="flex flex-row items-center justify-center space-x-2 md:space-x-4">
        {/* Sekcija 1 - Transakcija */}
        <div className="relative">
          <button onClick={toggleSection1} className="bg-gray-700 py-1 px-2 sm:py-2 sm:px-3 rounded-lg hover:bg-pink-500 hover:text-black transition-all text-xs sm:text-sm">
            {section1.current} <span className="ml-1">&#x25BC;</span>
          </button>
          {isSection1Open && (
            <ul className="absolute left-0 mt-1 bg-gray-700 text-white rounded-lg shadow-lg z-50 text-xs sm:text-sm">
              {section1.options.map(option => (
                <li
                  key={option}
                  className="py-1 px-2 sm:py-2 sm:px-3 hover:bg-pink-500 hover:text-black cursor-pointer"
                  onClick={() => handleSelection(section1, setSection1, option, setIsSection1Open)}
                >
                  {option}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Sekcija 2 - Država */}
        <div className="relative">
          <button onClick={toggleSection2} className="bg-gray-700 py-1 px-2 sm:py-2 sm:px-3 rounded-lg hover:bg-pink-500 hover:text-black transition-all text-xs sm:text-sm">
            {section2.current} <span className="ml-1">&#x25BC;</span>
          </button>
          {isSection2Open && (
            <ul className="absolute left-0 mt-1 bg-gray-700 text-white rounded-lg shadow-lg z-50 text-xs sm:text-sm">
              {section2.options.map(option => (
                <li
                  key={option}
                  className="py-1 px-2 sm:py-2 sm:px-3 hover:bg-pink-500 hover:text-black cursor-pointer"
                  onClick={() => handleSelection(section2, setSection2, option, setIsSection2Open)}
                >
                  {option}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Sekcija 3 - Grad */}
        <div className="relative">
          <button onClick={toggleSection3} className="bg-gray-700 py-1 px-2 sm:py-2 sm:px-3 rounded-lg hover:bg-pink-500 hover:text-black transition-all text-xs sm:text-sm">
            {section3.current} <span className="ml-1">&#x25BC;</span>
          </button>
          {isSection3Open && (
            <ul className="absolute left-0 mt-1 bg-gray-700 text-white rounded-lg shadow-lg z-50 text-xs sm:text-sm">
              {section3.options.map(option => (
                <li
                  key={option}
                  className="py-1 px-2 sm:py-2 sm:px-3 hover:bg-pink-500 hover:text-black cursor-pointer"
                  onClick={() => handleSelection(section3, setSection3, option, setIsSection3Open)}
                >
                  {option}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Sekcija 4 - Tip nekretnine */}
        <div className="relative">
          <button onClick={toggleSection4} className="bg-gray-700 py-1 px-2 sm:py-2 sm:px-3 rounded-lg hover:bg-pink-500 hover:text-black transition-all text-xs sm:text-sm">
            {section4.current} <span className="ml-1">&#x25BC;</span>
          </button>
          {isSection4Open && (
            <ul className="absolute left-0 mt-1 bg-gray-700 text-white rounded-lg shadow-lg z-50 text-xs sm:text-sm">
              {section4.options.map(option => (
                <li
                  key={option}
                  className="py-1 px-2 sm:py-2 sm:px-3 hover:bg-pink-500 hover:text-black cursor-pointer"
                  onClick={() => handleSelection(section4, setSection4, option, setIsSection4Open)}
                >
                  {option}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {/* Dugme Pretraga */}
      <button 
        onClick={handleSearch}
        className="bg-pink-500 text-black py-1 px-4 sm:py-2 sm:px-5 rounded-lg hover:bg-pink-600 transition-all focus:outline-none text-xs sm:text-sm">
        Pretraga
      </button>
    </div>
  );
};

export default MenuHome;